import { ISector } from 'features/settings/topology/types';
import { BaseService } from 'shared/services/BaseService';

class SectorService extends BaseService<ISector> {
  constructor() {
    super('sectors');
  }
}

export const sectorService = new SectorService();
